import { render, staticRenderFns } from "./HighlightCustomer.vue?vue&type=template&id=ff3ed53c&scoped=true"
import script from "./HighlightCustomer.vue?vue&type=script&lang=js"
export * from "./HighlightCustomer.vue?vue&type=script&lang=js"
import style0 from "./HighlightCustomer.vue?vue&type=style&index=0&id=ff3ed53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3ed53c",
  null
  
)

export default component.exports